import Route from '@ember/routing/route';

export default class OClassesTimeRoute extends Route 
{
	model() 
	{
		return this.modelFor("event");
	}
}
